import { notification } from "antd";
import axiosInstance from "../axiosInstance";
import { EditorialTree } from "../../pages/Enterprise/modules/EditorialTree/types";

const getEditorialTree = async (
  id: string,
  mainAccountId?: string
): Promise<EditorialTree> => {
  try {
    const response = await axiosInstance.get<EditorialTree>(
      `/editorial-tree/${id}`,
      {
        params: {
          mainAccountId,
        },
      }
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível retornar a Árvore Editorial.",
    });

    throw new Error(`${error}`);
  }
};

const deleteEditorialTree = async (
  id: string,
  mainAccountId?: string
): Promise<EditorialTree> => {
  try {
    const response = await axiosInstance.delete<EditorialTree>(
      `/editorial-tree/${id}`,
      {
        params: {
          mainAccountId,
        },
      }
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível deletar a Árvore Editorial.",
    });

    throw new Error(`${error}`);
  }
};

const createEditorialTree = async (
  id: string,
  data: EditorialTree,
  mainAccountId?: string
): Promise<EditorialTree> => {
  try {
    const queryParams = mainAccountId ? `?mainAccountId=${mainAccountId}` : "";
    const response = await axiosInstance.post<EditorialTree>(
      `/editorial-tree/${id}${queryParams}`,
      data
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível criar a Árvore Editorial.",
    });

    throw new Error(`${error}`);
  }
};

export const editorialTreeService = {
  getEditorialTree,
  createEditorialTree,
  deleteEditorialTree,
};
